import firebase from './firebase';
import { activateAppCheck } from './appCheck';

/**
 * Get Firebase instance (must already be initialized in index.js).
 * @returns {Object} Firebase app instance
 */
export const getFirebase = () => {
  try {
    return firebase.app();
  } catch (error) {
    throw new Error('Firebase not initialized. Please authenticate first.');
  }
};

/**
 * Activate App Check.
 */
export const initHelpPortalAuth = async () => {
  const app = getFirebase();
  activateAppCheck(app);

  // const auth = firebase.auth();
  // if (!auth.currentUser) {
  //   await auth.signInAnonymously();
  // }
};
